import store from "@/core/store";
import create from "@/apps/catalogs-categories/store/create";


export const connect = (opts = {}) => {
  store.registerModule('catalogs-categories$create', create);
};
